import React, { useState, useEffect } from "react";
import "../../components/DashboardModule/MyQuotations.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getRejectedQuotations } from "../../API/Api";

const Rejected = () => {
    const [rejectedEnquiries, setRejectedEnquiries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRejectedQuotations = async () => {
            try {
                const response = await getRejectedQuotations();
                if (response.status && response.data) {
                    setRejectedEnquiries(response.data);
                } else {
                    toast.error(response.message || "Failed to fetch rejected quotations");
                }
                setLoading(false);
            } catch (error) {
                toast.error(error.response?.data?.message || "Error fetching rejected quotations");
                console.error("Error fetching rejected quotations:", error);
                setLoading(false);
            }
        };

        fetchRejectedQuotations();
    }, []);

    if (loading) {
        return <div className="loading-spinner">Loading...</div>;
    }

    return (
        <div className="quo-container font-poppins">
            <div className="quo-header">
                <h2 className="quo-title">Rejected Quotations</h2>
                <div className="quo-actions"></div>
            </div>

            <table className="quo-table">
                <thead>
                    <tr>
                        <th>Order Id</th>
                        <th>Product Details</th>
                        <th></th>
                        <th>Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {rejectedEnquiries.map((enquiry) => (
                        <tr key={enquiry.enquiry_id}>
                            <td>{enquiry.order_id}</td>
                            <td>
                                <div className="product-details">
                                    <div className="product-name">
                                        {enquiry.product_details.product_name}
                                    </div>
                                   
                                </div>
                            </td>
                            <td>
                               
                            </td>
                            <td>
                                {new Date(enquiry.created_at).toLocaleDateString()}
                            </td>
                            <td>
                                {enquiry.latest_quotation?.status || 'Rejected'}
                                {enquiry.latest_quotation?.rejection_reason && (
                                    <div className="rejection-reason">
                                        Reason: {enquiry.latest_quotation.rejection_reason}
                                    </div>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Rejected;